<template>
  <v-container
    class="fill-height pa-4"
    fluid
  >
    <v-row
      shrink
      no-gutters
      align="center"
      justify="center"
      dense
      class="ma-4"
    >
      <v-stepper v-model="e1">
        <v-stepper-items>
          <v-stepper-content step="1" justify="center" class="pb-4">
            <v-card
                class="mb-12"
                flat
            >
              <v-card-title>
                <span class="headline" id="v-export-step-1">Export Assets from Section(s)</span>
              </v-card-title>

              <v-form
                ref="form"
                lazy-validation
              >
                <p>What would you like to do?</p>
                <v-radio-group v-model="task" :mandatory="true">
                  <v-radio label="Export Section" value="export-one"></v-radio> 
                </v-radio-group>

                <v-select
                  v-if="this.task == 'export-one'"
                  :items="sectionHeaders"
                  :menu-props="{ maxHeight: '400' }"
                  v-model="selectedSection"
                  id="v-export-step-2"
                  item-text="name"
                  item-value="id"
                  label="Which Section would you like to export?*"
                  required
                  :rules="ruleIfSingleSection"
                ></v-select>
              </v-form>
              <JobProgress ref="exportProgress" v-if="this.downloadingSectionData" :importJobId="this.exportJobId"></JobProgress>
            </v-card>

            <v-row justify="center" class="mb-6">
              <v-btn 
                v-if="this.task == 'export-one'"
                color="blue-grey lighten-5" 
                class="mr-4"
                :disabled="(this.task == 'export-one' && this.selectedSection == null)|| this.downloadingSectionData"
                @click="downloadSectionData()"
                height="64px"
              >
                <v-icon 
                    v-if="this.downloadingSectionData" 
                    size="28" 
                    color="white" dark
                >
                    mdi-loading mdi-spin
                </v-icon>
                <span id="v-export-step-3" v-else>Export Section (Excel)</span>
              </v-btn>
              <v-btn 
                v-else
                color="blue-grey lighten-5" 
                class="mr-4"
                :disabled="this.downloadingSectionData"
                @click="downloadAllSectionData()"
                height="64px"
              >
                <v-icon 
                    v-if="this.downloadingSectionData" 
                    size="28" 
                    color="white" dark
                >
                    mdi-loading mdi-spin
                </v-icon>
                <span id="v-export-step-3" v-else>Export All Sections (Excel)</span>
              </v-btn>
              <!--
              <v-btn 
                v-if="this.task == 'export-one'"
                color="blue-grey lighten-5" 
                class="mr-4"
                :disabled="(this.task == 'export-one' && this.selectedSection == null)|| this.downloadingSectionData"
                @click="singlePDFExport()"
              >
                <v-icon 
                    v-if="this.downloadingSectionData" 
                    size="28" 
                    color="white" dark
                >
                    mdi-loading mdi-spin
                </v-icon>
                <span id="v-export-step-3" v-else>Export Section (PDF)</span>
              </v-btn>
              <v-btn 
                v-else
                color="blue-grey lighten-5" 
                class="mr-4"
                :disabled="this.downloadingSectionData"
                @click="AllPDFExport()"
              >
                <v-icon 
                    v-if="this.downloadingSectionData" 
                    size="28" 
                    color="white" dark
                >
                    mdi-loading mdi-spin
                </v-icon>
                <span id="v-export-step-3" v-else>Export All Sections (PDF)</span>
              </v-btn>
              -->
              
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper> 
    </v-row> 
  </v-container>
</template>

<script>
import CONFIG from '../../../appconfig.json'
import { mapActions } from 'vuex'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

import JobProgress from '../../shared/JobProgress'

export default {
  name: 'AssetExport',
  components: {
    JobProgress
  },
  props: {

  },
  computed:{
    ...mapState("assetxpstate", [
        "sectionHeaders",
        "section"
    ]),
  },
  mounted:  function () {
    this.GetSectionHeaders();
    this.selectedSection = this.section !== null ? this.section.id : null;
  },
  data(){ 
    return {
      e1: 1,
      task: null,
      exportJobId: null,
      selectedSection: '', 
      importCompletion: {},
      downloadedSectionData: false,
      downloadingSectionData: false,
      inputRules: [
        v => v !== null || 'This is a required field.',
        v => v !== '' || 'This is a required field.'
      ],
      ruleIfSingleSection: [
        v => (this.task == 'export-one' && v !== null) || 'This is a required field.',
        v => (this.task == 'export-one' && v !== '') || 'This is a required field.'
      ]
    }
  },
  methods:{
    ...mapActions("assetxpstate", [
        "GetAssetImportTemplate",
        "GetSectionHeaders",
        "ExportAssetsBySection",
        "ExportAssetsAllSections",
        "StartNewJob",
        "PDFExportAllSections",
        "PDFExportAssetsBySection"
    ]),
    ...mapGetters("authentication", [
      "GetAuthHeaderObj"
    ]),

    async downloadSectionData() {
      this.downloadedTemplate = true;
      this.downloadingSectionData = true;

      this.ExportAssetsBySection(this.selectedSection).then((response) =>{
        this.downloadingSectionData = false;
        this.downloadedSectionData = true;
      });
    },
    async downloadAllSectionData() {
      this.downloadedTemplate = true;
      this.downloadingSectionData = true;

      var newJob = {
        name: "Export All Sections Data",
        totalCount: 0,
        jobType: 1,
        status: 0
      };

      await this.StartNewJob(newJob).then((response) =>{
        this.exportJobId = response.data.id;
        this.$refs.exportProgress.setJobId({ jobId: this.exportJobId });
      });

      var request = { jobid: this.exportJobId };
      this.ExportAssetsAllSections(request).then((response) =>{
        this.downloadingSectionData = false;
        this.downloadedSectionData = true;
      });
    },
    async singlePDFExport()
    {
      this.downloadedTemplate = true;
      this.downloadingSectionData = true;

      this.PDFExportAssetsBySection(this.selectedSection).then((response) =>{
        this.downloadingSectionData = false;
        this.downloadedSectionData = true;
      });
    },
    async AllPDFExport()
    {
      this.downloadedTemplate = true;
      this.downloadingSectionData = true;

      var request = { };
      this.PDFExportAllSections(request).then((response) =>{
        this.downloadingSectionData = false;
        this.downloadedSectionData = true;
      });
    }
  }
}
</script> 

<style>

</style>